import { makeStyles, Theme, Tooltip, TooltipProps } from '@material-ui/core';
import { MouseEventHandler } from 'react';

type IconButtonProps = {
  className?: String;
  tooltip?: String;
  tooltipPlacement?: 
  | 'bottom-end'
  | 'bottom-start'
  | 'bottom'
  | 'left-end'
  | 'left-start'
  | 'left'
  | 'right-end'
  | 'right-start'
  | 'right'
  | 'top-end'
  | 'top-start'
  | 'top';
  disabled?: Boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
};

type StyleProps = {
  disabled: Boolean;
};

const useStyles = makeStyles<Theme, StyleProps>(() => ({
  tooltip: {
    backgroundColor: ({disabled}) => disabled ? '#E82749' : '#7F82AA'
  }
}));

export const IconButton: React.FC<IconButtonProps> = ({
  className,
  children,
  tooltip,
  tooltipPlacement,
  disabled,
  onClick
}) => {
  const classes = useStyles({ disabled });

  return (
    <Tooltip title={tooltip || ''} placement={tooltipPlacement} classes={{ tooltip: classes.tooltip }}>
      <div>
        <button
          type="button"
          className={`bg-transparent cursor-pointer flex items-center justify-center outline-none focus:outline-none ${disabled ? 'pointer-events-none opacity-50' : ''} ${className || ''}`}
          onClick={onClick}
          >
          {children}
        </button>
      </div>
    </Tooltip>
  );
};
